// shared-data.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SharedDataService {
  private dataSource = new BehaviorSubject<any>(null);
  currentData = this.dataSource.asObservable();

  private eventList = new BehaviorSubject<any>(null);
  eventListData = this.eventList.asObservable();

  private ctaDisable = new BehaviorSubject<any>(false);
  ctaDisableData = this.ctaDisable.asObservable();

  sendData(data: any) {
    this.dataSource.next(data);
  }

  eventDates(data: any) {
    this.eventList.next(data);
  }

  disableCta(data:any){
    this.ctaDisable.next(data);
  }
}